



























































































import { Component, Vue } from "vue-property-decorator";
import axios, { AxiosRequestConfig } from "axios";
import api from "../../api/index";

@Component({
  components: {},
})
export default class Home extends Vue {
  gender = "female";
  firstName = null;
  lastName = null;
  password = "";
  passwordConfirm = null;
  phoneNumber = null;
  apiErrorMessage = "";
  registrationToken = null;

  async mounted() {
    await api.init();
    try {
      const res = await api.get(
        `internal/invitations/${this.$route.params.token}`
      );
      this.firstName = res.data.first_name;
      this.lastName = res.data.last_name;
      this.phoneNumber = res.data.mobile_phone_number;
      this.gender = res.data.gender || "female";
      this.registrationToken = res.data.registration_token;
    } catch (e) {
      if (e.response.status === 404) {
        this.apiErrorMessage = "Votre invitation n'est plus valide.";
      }
    }
  }

  get buttonIsInactive() {
    if (
      this.password &&
      this.passwordConfirm &&
      this.goodPassword &&
      this.gender &&
      this.firstName &&
      this.lastName &&
      this.phoneNumber
    ) {
      return !(this.password === this.passwordConfirm);
    } else {
      return true;
    }
  }

  get goodPassword() {
    if (this.password !== "") {
      const atLeastOneMaj = /[A-Z]/.test(this.password);
      const atLeastOneNumber = /[0-9]/.test(this.password);
      const atLeastEightChar = this.password.length >= 8;
      return atLeastOneMaj && atLeastOneNumber && atLeastEightChar;
    } else {
      return true;
    }
  }

  async checkPasswords() {
    if (this.password && this.passwordConfirm && this.goodPassword) {
      if (this.password === this.passwordConfirm) {
        const params = {
          registration_token: this.registrationToken,
          // activation_token: "",
          invitation_token: this.$route.params.token,
          registration: {
            gender: this.gender,
            first_name: this.firstName,
            last_name: this.lastName,
            password: this.password,
          },
        };
        try {
          const res = await api.put("internal/registration", params);
          this.$router.push({ name: "success" });
        } catch (e) {
          if (e.response.status === 422) {
            this.apiErrorMessage = "Une erreur est survenue";
          }
        }
      }
    }
  }
}
